<script>
export default {
    name: "AdmissionReport",

    data() {

        return {
            patients: [], 
            patstatus: [],
            filter: {
                search: '',
                dateFrom: window.moment().format('YYYY-MM-DD'),
                dateTo: window.moment().format('YYYY-MM-DD'),
                admittedBy: '',
                ward: '',
                special:  '',
            },
        };
    },

    watch: {

        "filter.special"() {
            this.fetchPatients();
        },
    },

    mounted() {

        this.fetchPatients();
        this.fetchPatStatus();
        
    },

    methods: {

        fetchPatients() {
            this.$root.loading = true;
            let url = `PatientsReports/GetPatientsAdmssionReport?Datefrom=${this.filter.dateFrom}&Dateto=${this.filter.dateTo}`;
            url += this.filter.search ? `&SearchText=${this.filter.search}` : ``;
            url += this.filter.admittedBy ? `&AdmittedBy=${this.filter.admittedBy}` : ``;
            url += this.filter.ward ? `&Ward=${this.filter.ward}` : ``;
            //url += `&Special=${this.filter.special}`;
            url += this.filter.special ? `&Special=${this.filter.special}` : ``;
             this.$http.get(url).then(response => {
                this.patients = response.data;
                this.$root.loading = false;
            }).catch(() => {
                this.$root.loading = false;
            });
        },
        fetchPatStatus() {

return this.$http.get(`Shared/GetPatStatus`).then(response => {
    this.patstatus = response.data;
}).catch(() => {});
},
    
        printAdmissionReport() {

            window.open(`/reports/patients/patients-admission-report/print?page=${this.filter.page}&pageSize=${this.filter.pageSize}&dateFrom=${this.filter.dateFrom}&dateTo=${this.filter.dateTo}&admittedBy=${this.filter.admittedBy}&ward=${this.filter.ward}`, '_blank', `ReportPrint`, "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes");
        },
        printAdmissionNote(patient) {

            window.open(`/outpatient/admission-note/print/${patient.patienT_ID}/${patient.visitNo}`, '_blank', `ReportPrint`, "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes");
        },
    },
}
</script>
<template>
<tail-base-layout>
  <template v-slot:breadcrum>
      <div class="bg-blue-800 p-tiny text-xs text-white rounded">
         <nav class="bg-grey-light rounded font-sans w-full p-tiny">
           <ol class="list-reset flex text-grey-dark">
             <li><router-link :to="{name : 'reports.patients'}">Patient Reports</router-link></li>
             <li><span class="mx-2">/</span></li>
             <li>Admission Report</li>
           </ol>
         </nav>
      </div>
  </template>
  <template v-slot:content>
      <tail-card>
        <template v-slot:card-header>
            <h5 class="font-bold text-sm">Admission Report</h5>
        </template>
        <template v-slot:card-body>
          <div class="flex flex-wrap">
              <div class="md:w-1/12 sm:w-full p-tiny">
                  <label for="grid-search" class="label-control">Search:</label>
                  <input type="text" v-model.trim="filter.search" id="grid-search" class="input-control input-sm text-xs">
              </div>
              <div class="md:w-1/6 sm:w-full p-tiny">
                  <label for="grid-date-from" class="label-control">From:</label>
                  <input type="date" v-model="filter.dateFrom" id="grid-date-from" class="input-control input-sm text-xs">
              </div>
              <div class="md:w-1/6 sm:w-full p-tiny">
                  <label for="grid-date-to" class="label-control">To:</label>
                  <input type="date" v-model="filter.dateTo" id="grid-date-to" class="input-control input-sm text-xs">
              </div>
               
              <div class="md:w-1/12 sm:w-full p-tiny mt-4">
                  <button 
                    @click.prevent="fetchPatients" 
                        class="btn-sm btn-info text-xs rounded">
                            <i class="fa fa-filter"></i> Filter</button>
              </div>
              
              <!-- <div class="md:w-1/12 sm:w-full p-tiny mt-4">
                  <button class="btn-sm btn-primary text-xs rounded" @click.prevent="$root.exportToExcel(`patient-admission-report`, `admissionReport`)"><i class="fa fa-file-excel"></i> Export</button>
              </div> -->
              <div class="md:w-1/12 sm:w-full p-tiny mt-4">
                  <button 
                    class="btn-sm btn-info text-xs rounded" @click.prevent="printAdmissionReport">
                        <i class="fa fa-print"></i> Print</button>
              </div>
          </div>
          <div class="w-full overflow-auto">
              <table class="table table-hover" id="admissionReport">
                  <thead class="bg-blue-500 text-xs text-white">
                        <tr class="w-full flex">
                            <th class="p-tiny flex-1">NO</th>
                            <th class="p-tiny flex-1">Admission Date</th>
                            <th class="p-tiny flex-1">Discharge Date</th>
                            <th class="p-tiny flex-1">Member No</th>
                            <th class="p-tiny flex-1">IP No</th>
                            <th class="p-tiny w-1/6">Name</th>
                            
                        </tr>
                  </thead>
                  <tfoot>
                      <tr class="flex w-full">
                          <th class="p-tiny w-1/2"></th>
                          <th class="p-tiny w-1/2 text-right">Total Admissions: 
                            {{ patients ? patients.length : 0 }}</th>
                      </tr>
                  </tfoot>
                  <tbody 
                    class="text-xs bg-gray-100 flex flex-col items-center overflow-auto" 
                    style="max-height:65vh;">
                      <tr class="flex w-full" v-for="(patient, idx) in patients" :key="idx">
                          <td class="p-tiny flex-1">{{ patient.notificationNo }}</td>
                          <td class="p-tiny flex-1">{{ patient.admissionDate | dateFormat }}</td>
                          <td class="p-tiny flex-1">{{ patient.dischargeDate | dateFormat }}</td>
                          <td class="p-tiny flex-1">{{ patient.memberNo }}</td>
                          <td class="p-tiny flex-1">{{ patient.ipNo }}</td>
                          <td class="p-tiny w-1/6"> {{ patient.patientName }}</td>
                         
                      </tr>
                  </tbody>
              </table>
          </div>
        </template>
      </tail-card>
  </template>
</tail-base-layout>
</template>